/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
    publishProject : null,
};


const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.PublishProjectAction.REQUEST_PUBLISH_PROJECT:
      return {
        ...state,
    };
    case actions.PublishProjectAction.PUBLISH_PROJECT_RECEIVED:
          return{
      ...state,
      publishProject : action.data,
    };

    default:
      return state;
  }
};

export default reducer;
